<div class="report-details">
  <h2 class="report-details__header ">
    <span>{{ data.element.name }}</span>
    <mat-icon class="report-details__close" (click)="close()">close</mat-icon>
  </h2>
  <div class="report-details__input">
    <mat-icon matPrefix>search</mat-icon>
    <input matInput [formControl]="search"/>
  </div>
  <div class="report-details__table">
    @defer (when tableData && tableData.length) {
      <ostso-table
        [controls]="false"
        [updateList]="updateList.asObservable()"
        (sortedColumn)="onSortedColumn($event)"
        [lastIsSortable]="true"
      >
        @for (i of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]; track i) {

          <ng-template [ostsoCellTemplate]="'cell'+ i" let-element="$implicit">
            <div class="item-value"
                 [class.red]="data.legends[element['cell' + i].id] && data.legends[element['cell' + i].id].low.max > element['cell' + i].value"
                 [class.green]="data.legends[element['cell' + i].id] && data.legends[element['cell' + i].id].high.min <= element['cell' + i].value"
                 [class.yellow]="data.legends[element['cell' + i].id] && data.legends[element['cell' + i].id].middle.min <= element['cell' + i].value && data.legends[element['cell' + i].id].middle.max > element['cell' + i].value"
            >
              {{ Math.round(element['cell' + i].value*100)/100 }}
            </div>
          </ng-template>
        }
        <ng-template ostsoCellTemplate="name" let-element="$implicit">
          <div class="property-item">
            <div class="property-name">{{ element['name'] }}</div>
            <div class="property-address">{{ element['address'] }}</div>
          </div>
        </ng-template>
      </ostso-table>
    }
    @placeholder {
      <div>Идет загрузка данных...</div>
    }
  </div>
</div>
